var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"touch",rawName:"v-touch:tap.stop",value:(_vm.openInfoModal),expression:"openInfoModal",arg:"tap",modifiers:{"stop":true}}],style:(_vm.style),on:{"click":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }